export enum MESSAGE_ERROR {
  INVALID_LIST_NAME = `The name you entered is invalid. Please only use letters, numbers, "-", and "_" as special characters.`,
}
